import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router';

import NotFound from '@/pages/notfound';
import Styleguide from '@/pages/styleguide';
import { RENDERING_MODES } from '@/config/constants';
import commercialErrorReportRoutes from '@/router/routes/commercial-errorreport';
import oncallErrorReportRoutes from '@/router/routes/oncall-errorreport';
import mypagesRoutes from '@/router/routes/my-pages';
import { renderMode } from '@/helpers';
import searchRoutes from '@/router/routes/search';
import store from '@/store';
import VerifyAndChangeEmail from '@/components/verifyandchangeemail.vue';

// Base URL depending on the rendering mode
const my_pages_url = gavlegardarna.webapp_config.url_to_mypages || '/#/';
const search_url = gavlegardarna.webapp_config.url_to_search || '/sok-ledigt';

// Styleguide route configuration
const styleguideRoute = {
  path: '/styleguide',
  name: 'styleguide',
  component: Styleguide,
  meta: {
    requiresAuth: false,
    layout: 'default',
  },
};

// Define the routes based on rendering mode
const routes = (() => {
  const defaults = [
    {
      path: '/404',
      component: NotFound,
    },
    styleguideRoute,
  ];

  switch (renderMode()) {
    case RENDERING_MODES.MY_PAGES:
      return [styleguideRoute, ...mypagesRoutes];
    case RENDERING_MODES.SEARCH:
      return [styleguideRoute, ...searchRoutes];
    case RENDERING_MODES.COMMERCIAL_ERRORREPORT:
      return [styleguideRoute, ...commercialErrorReportRoutes];
    case RENDERING_MODES.ONCALL_ERRORREPORT:
      return [styleguideRoute, ...oncallErrorReportRoutes];
    case RENDERING_MODES.CHANGE_EMAIL_BANKID:
      let changeEmailBankIDRoutes = [
        {
          path: '/',
          name: 'VerifyAndChangeEmail',
          component: VerifyAndChangeEmail,
        },
        {
          path: '/login/:sessionId',
          name: 'VerifyAndChangeEmailWithSession',
          component: VerifyAndChangeEmail
        },
      ]
      return [...changeEmailBankIDRoutes]
    default:
      return defaults;
  }
})();

// Create the router instance
const router = createRouter({
  history: createWebHashHistory(
    renderMode() === RENDERING_MODES.MY_PAGES
      ? my_pages_url
      : renderMode() === RENDERING_MODES.SEARCH
        ? search_url
        : '/',
  ),
  routes,
  scrollBehavior(to, from) {
    if (to.path === from.path && to.query && to.query.page === from.query.page) {
      return false;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// Before each route, perform actions like clearing errors or managing analytics
router.beforeEach((to, from, next) => {
  if (from.name=="ErrorReportConfirm" && to.name=="ErrorReportEditRow") next(false)

  if (renderMode() === RENDERING_MODES.MY_PAGES && store.getters.authStatus !== false && to.name != "Register" && to.name!="ErrorReportConfirm" && to.name!="ErrorReportEditRow" && to.name != 'ErrorReportAddNewRowOrFinish') {
    if(!store.getters.claims || store.getters.claims.length === 0) store.cache.dispatch('fetchProfile');
    if(!store.getters.contracts || Object.keys(store.getters.contracts).length === 0) store.cache.dispatch('fetchContracts');
    if(!store.getters.invoices || Object.keys(store.getters.invoices).length === 0) store.cache.dispatch('fetchInvoices');
  }

  /*if (from.name=="ErrorReportConfirm" && to.name=="ErrorReportEditRow") next(false);
  else */next();
});

// After each route, update classes for transitions or analytics
router.afterEach((to, from) => {
  if (from && from.name) {
    document.querySelector('body').classList.remove('at-route-' + from.name.toLowerCase());
  }
  if (to && to.name) {
    document.querySelector('body').classList.add('at-route-' + to.name.toLowerCase());
  }
});

export default router;
